import script from "./PlanChangeBlockedDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanChangeBlockedDialog.vue?vue&type=script&setup=true&lang=js"

import "./PlanChangeBlockedDialog.vue?vue&type=style&index=0&id=01ab1b11&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01ab1b11"]])

export default __exports__